/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 *
 */

//'use strict';

//var Promise = require('./Promise');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

//var ExecutionEnvironment = require('./ExecutionEnvironment');

export const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var DEFAULT_TIMEOUT = 15000;
var DEFAULT_RETRIES = [1000, 3000];

/**
 * Makes a POST request to the server with the given data as the payload.
 * Automatic retries are done based on the values in `retryDelays`.
 */
function fetchWithRetries(uri, initWithRetries) {
  var _ref = initWithRetries || {},
      fetchTimeout = _ref.fetchTimeout,
      retryDelays = _ref.retryDelays,
      init = _objectWithoutProperties(_ref, ['fetchTimeout', 'retryDelays']);

  var _fetchTimeout = fetchTimeout != null ? fetchTimeout : DEFAULT_TIMEOUT;
  var _retryDelays = retryDelays != null ? retryDelays : DEFAULT_RETRIES;

  var requestsAttempted = 0;
  var requestStartTime = 0;
  return new Promise(function (resolve, reject) {
    /**
     * Sends a request to the server that will timeout after `fetchTimeout`.
     * If the request fails or times out a new request might be scheduled.
     */
    function sendTimedRequest() {
      requestsAttempted++;
      requestStartTime = Date.now();
      var isRequestAlive = true;

      console.warn("fetching from the server.. request number: ",+requestsAttempted);
      var API = require('aws-amplify').API,
           graphqlOperation = require('aws-amplify').graphqlOperation;


      var requestTimeout = setTimeout(function () {
        isRequestAlive = false;
        if (shouldRetry(requestsAttempted)) {
          process.env.NODE_ENV !== 'production' ? console.warn('fetchWithRetries: HTTP timeout, retrying.') : void 0;
          retryRequest();
        } else {
          reject(new Error('fetchWithRetries(): Failed to get response from server, tried ' + requestsAttempted + ' times.'));
        }
      }, _fetchTimeout);

      API.graphql(graphqlOperation(uri, init)).then(function (response) {
        console.log("response: ",response);
        clearTimeout(requestTimeout);
        if (isRequestAlive) {
          if(response) {
          // We got a response, we can clear the timeout.
            resolve(response);
          } else if (shouldRetry(requestsAttempted)) {
            // Fetch was not successful, retrying.
            // TODO(#7595849): Only retry on transient HTTP errors.
            process.env.NODE_ENV !== 'production' ? console.warn('fetchWithRetries: HTTP error, retrying.') : void 0;
            retryRequest();
          } else {
            // Request was not successful, giving up.
            var error = new Error('fetchWithRetries(): Still no successful response after ' + requestsAttempted +'retries, giving up.');
            error.response = response;
            reject(error);
          }
        }
      })['catch'](function (error) {
        console.log('Error in fetch-with-retries: ',error);
        clearTimeout(requestTimeout);
        // console.log("error: ",error);
        // console.log("Object.hasOwnProperty.call(error, errors): ",Object.hasOwnProperty.call(error, "errors"));
        // console.log("error.errors.length: ",error.errors.length);
        // console.log("error.errors[0].errorType: ",error.errors[0].errorType);
        if (
          Object.hasOwnProperty.call(error, "errors") &&
          Array.isArray(error.errors) &&
          error.errors.length &&
          error.errors[0].errorType === "Lambda:Handled"
        ) {
          reject(error);
        }
        else if (shouldRetry(requestsAttempted)) {
          retryRequest();
        } else {
          reject(error);
        }
      });
    }

    /**
     * Schedules another run of sendTimedRequest based on how much time has
     * passed between the time the last request was sent and now.
     */
    function retryRequest() {
      var retryDelay = _retryDelays[requestsAttempted - 1];
      var retryStartTime = requestStartTime + retryDelay;
      // Schedule retry for a configured duration after last request started.
      setTimeout(sendTimedRequest, retryStartTime - Date.now());
    }

    /**
     * Checks if another attempt should be done to send a request to the server.
     */
    function shouldRetry(attempt) {
      //console.log("canUseDOM: ",canUseDOM)
      return canUseDOM && attempt <= _retryDelays.length;
    }

    sendTimedRequest();
  });
}

export default fetchWithRetries;
